import { combineProviders } from '../provider-helpers';
/**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */
export default (function (extensionProviders) {
  var _combineProviders = combineProviders(extensionProviders),
    invokeSingle = _combineProviders.invokeSingle,
    invokeList = _combineProviders.invokeList;
  return {
    getExtensions: function getExtensions() {
      return invokeList('getExtensions');
    },
    getExtension: function getExtension(type, key) {
      return invokeSingle('getExtension', [type, key]);
    },
    search: function search(keyword) {
      return invokeList('search', [keyword]);
    },
    getAutoConverter: function getAutoConverter() {
      return invokeList('getAutoConverter');
    }
  };
});